import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "UserAvatar"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12ZM12 5.25C9.92893 5.25 8.25 6.92893 8.25 9C8.25 11.0711 9.92893 12.75 12 12.75C14.0711 12.75 15.75 11.0711 15.75 9C15.75 6.92893 14.0711 5.25 12 5.25ZM12 11.25C10.7574 11.25 9.75 10.2426 9.75 9C9.75 7.75736 10.7574 6.75 12 6.75C13.2426 6.75 14.25 7.75736 14.25 9C14.25 10.2426 13.2426 11.25 12 11.25ZM7.50012 19.785V18.285C7.43158 16.9672 8.4335 15.8384 9.75012 15.75H14.2501C15.5698 15.8384 16.5729 16.9719 16.5001 18.2925V19.7925C13.7189 21.4127 10.2814 21.4127 7.50012 19.7925V19.785ZM18.0001 18.2325V18.675C20.7814 16.1873 21.7392 12.2413 20.4077 8.75538C19.0762 5.26947 15.7317 2.96678 12.0001 2.96678C8.26857 2.96678 4.92406 5.26947 3.59257 8.75538C2.26107 12.2413 3.21879 16.1873 6.00012 18.675V18.2325C5.95352 16.1039 7.62261 14.3314 9.75012 14.25H14.2501C16.3758 14.3353 18.0427 16.1055 18.0001 18.2325Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/UserAvatar.vue"]]);
